import { useMutation } from '@apollo/client/react';
import { useEffect, useMemo } from 'react';

import {
  DirectVisitorDetailDialogProfileFragment,
  FetchLineAccountProfileDocument,
  LineVisitorDetailDialogProfileFragment,
  PatientDetailDialogProfileFragment,
  WebVisitorDetailDialogProfileFragment,
} from '~/graphql/generated/graphql';

type Props = {
  patient:
    | DirectVisitorDetailDialogProfileFragment
    | WebVisitorDetailDialogProfileFragment
    | PatientDetailDialogProfileFragment
    | LineVisitorDetailDialogProfileFragment;
};

export const useFetchLineProfile = (props: Props) => {
  const { patient } = props;
  const visitor = patient.__typename === 'LineVisitor' ? patient : undefined;
  const [fetchLineAccountProfile, { data }] = useMutation(FetchLineAccountProfileDocument);
  const active = useMemo(() => !!data?.fetchLineAccountProfile?.lineVisitor?.active, [data]);

  useEffect(() => {
    (async () => {
      if (visitor?.__typename !== 'LineVisitor' || !visitor.id) {
        return;
      }
      await fetchLineAccountProfile({
        variables: {
          input: {
            lineVisitorId: visitor.id,
          },
        },
      });
    })();
  }, [fetchLineAccountProfile, visitor]);

  return { active };
};
